<template>
  <section id="container-red-x">
    <slot></slot>
  </section>
</template>

<script>
  export default {
    name: 'ContainerRedX'
  }
</script>

<style lang="scss" scoped>

  section#container-red-x {
    background: url("../assets/background/bg_x_for_component.png"), #cc0000 fixed no-repeat center center;
    background-origin: border-box;
    background-size: cover;
  }
</style>
